function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdoBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M354.706,184.422H157.292c-4.467,0-8.089,3.622-8.089,8.089s3.621,8.089,8.089,8.089h197.414 c4.468,0,8.089-3.622,8.089-8.089S359.174,184.422,354.706,184.422z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M354.707,126.191H256c-4.468,0-8.089,3.622-8.089,8.089c0,4.467,3.621,8.089,8.089,8.089h98.707 c4.468,0,8.089-3.622,8.089-8.089C362.796,129.812,359.176,126.191,354.707,126.191z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M354.706,229.994H157.292c-4.468,0-8.089,3.622-8.089,8.089c0,4.467,3.622,8.089,8.089,8.089h197.414 c4.468,0,8.089-3.622,8.089-8.089C362.795,233.616,359.174,229.994,354.706,229.994z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M354.706,275.566H157.292c-4.468,0-8.089,3.622-8.089,8.089c0,4.467,3.622,8.089,8.089,8.089h197.414 c4.468,0,8.089-3.622,8.089-8.089C362.795,279.188,359.174,275.566,354.706,275.566z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M421.555,32.669H205.949C204.541,14.421,189.253,0,170.65,0s-33.889,14.421-35.297,32.669H90.445 c-4.468,0-8.089,3.622-8.089,8.089v344.356c0,4.467,3.621,8.089,8.089,8.089s8.089-3.622,8.089-8.089V48.848h36.701v95.238 c0,11.995,9.758,21.752,21.752,21.752c11.995,0,21.752-9.758,21.752-21.752V82.918c0-4.467-3.621-8.089-8.089-8.089 s-8.089,3.622-8.089,8.089v61.167c0,3.074-2.5,5.574-5.574,5.574c-3.074,0-5.574-2.5-5.574-5.574V48.848h262.052v95.617 c0,4.467,3.621,8.089,8.089,8.089s8.089-3.622,8.089-8.089V40.759C429.644,36.29,426.023,32.669,421.555,32.669z M151.633,32.669 c1.34-9.308,9.345-16.491,19.018-16.491c9.671,0,17.677,7.183,19.017,16.491H151.633z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M421.555,168.732c-4.468,0-8.089,3.622-8.089,8.089v196.262H279.569c-4.468,0-8.089,3.622-8.089,8.089v114.649H98.535 V417.47c0-4.467-3.622-8.089-8.089-8.089c-4.468,0-8.089,3.622-8.089,8.089v86.441c0,4.467,3.621,8.089,8.089,8.089h263.371 c2.145,0,4.202-0.852,5.721-2.37l67.739-67.737c1.516-1.516,2.368-3.574,2.368-5.72v-55.001V176.821 C429.644,172.354,426.023,168.732,421.555,168.732z M413.467,432.823l-62.999,62.998h-62.808v-106.56h125.808V432.823z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdoBusiness);
export default __webpack_public_path__ + "static/media/edo_business.9ec8737e49728a1819dfcacbdce2739f.svg";
export { ForwardRef as ReactComponent };